import { UncontrolledDropdown, DropdownMenu, DropdownToggle, DropdownItem, Badge } from 'reactstrap'
import { Settings, Power } from 'react-feather'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import jwt_decode from 'jwt-decode'

import Avatar from '@components/avatar'
import defaultAvatar from '@src/assets/images/portrait/portrait.png'

import { logout } from '../../../../redux/requests/auth'

const UserDropdown = () => {
	const dispatch = useDispatch()

	const token = useSelector((state) => state.auth.login.data?.token)
	const account = useSelector((state) => state.account.info?.data)
	const decodedToken = jwt_decode(token)

	const handleLogout = () => {
		logout(dispatch)
	}

	return (
		<UncontrolledDropdown tag="li" className="dropdown-user nav-item">
			<DropdownToggle href="/" tag="a" className="nav-link dropdown-user-link" onClick={(e) => e.preventDefault()}>
				<div className="flex">
					<div style={{ flex: '1', display: 'd-flex', justifyContent: 'space-between', alignItems: 'center' }}>
						<Badge color="light-info">
							<img
								src={require(`@src/assets/images/itembank/gcent.png`).default}
								height={17}
								width={17}
								className=""
								style={{ position: 'relative', top: '-2px' }}
							/>
							: {account?.GCent?.toLocaleString()}
						</Badge>
						<span style={{ margin: '0 5px' }}></span>
						<div style={{ margin: '3px 0' }}></div>
						<Badge color="light-warning">
							<img
								src={require(`@src/assets/images/itembank/wcoin.png`).default}
								height={17}
								width={17}
								className=""
								style={{ position: 'relative', top: '-2px' }}
							/>
							: <small>{account?.WCoin?.toLocaleString()}</small>
						</Badge>
					</div>
				</div>
				<div className="user-nav d-sm-flex d-none">
					<h3 className="user-name fw-bolder">{decodedToken?.username}</h3>
					<span className="user-status">
						{decodedToken?.isAdmin === 1 ? (
							<Badge color="light-danger" pill>
								Administrator
							</Badge>
						) : decodedToken?.isAdmin === 2 ? (
							<Badge color="light-warning" pill>
								Moderator
							</Badge>
						) : (
							<Badge color="light-success" pill>
								Thành viên
							</Badge>
						)}
					</span>
				</div>
				<Avatar img={defaultAvatar} imgHeight="40" imgWidth="40" status="online" />
			</DropdownToggle>
			<DropdownMenu end>
				<DropdownItem tag={Link} to="/account" onClick={(e) => e.preventDefault()}>
					<Settings size={14} className="me-75" />
					<span className="align-middle">Tài khoản</span>
				</DropdownItem>
				<DropdownItem divider />
				<DropdownItem onClick={handleLogout}>
					<Power size={14} className="me-75" />
					<span className="align-middle">Đăng xuất</span>
				</DropdownItem>
			</DropdownMenu>
		</UncontrolledDropdown>
	)
}

export default UserDropdown
